import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { FormLabel } from '@mui/material';
import { FormGroup, FormControl } from '@mui/material';
import { InputLabel } from '@mui/material';
import  Select ,{SelectChangeEvent} from '@mui/material/Select';
import { MenuItem } from '@mui/material';

type ImageManagementFormsType = {
    dicomDatalist:{
        series:string,
        seriesNumber:number,
        share:boolean,
        protocol:string
    }[]
    getContentsData:(value:string,name:string)=>void
    getDicomDatalist:(value:{series:string,seriesNumber: number,protocol: string,share: boolean}[])=>void
}

export default function ImageManagementForms(props:ImageManagementFormsType) {

  const [dicomDatalist,setDicomDatalist]= React.useState(props.dicomDatalist);
  const [update, setUpdate] = React.useState(false);

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
  <div>
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          画像情報
        </Typography>
        <Grid container spacing={3}>
            {dicomDatalist.map((dicomData,index)=>{
                return(
                    <Grid item xs={12} sm={12} display={{sm:'flex',xs:'grid'}} gap={3}>
                        <FormControl fullWidth>
                            <TextField
                            id="filled-read-only-input"
                            label="SeriesUId"
                            defaultValue={dicomData.seriesNumber}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="filled"
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <TextField
                            id="filled-read-only-input"
                            label="プロトコル"
                            defaultValue={dicomData.protocol}
                            onChange={(event)=>{
                                var olddata = dicomDatalist;
                                olddata[index]['protocol'] = event.target.value;
                                setDicomDatalist(olddata);
                                props.getDicomDatalist(olddata);
                            }}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">公開</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={Number(dicomData.share)}
                                label="Share"
                                onChange={(event:SelectChangeEvent<number>) => {
                                    var olddata = dicomDatalist;
                                    olddata[index]['share'] = Boolean(event.target.value as number);
                                    setDicomDatalist(olddata);
                                    props.getDicomDatalist(olddata);
                                    setUpdate(!update);                        
                                }}
                            >
                                <MenuItem value={0}>非公開</MenuItem>
                                <MenuItem value={1}>公開</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                )
            })}
        </Grid>
      </React.Fragment>
    </div>
  );
}